import { createAction } from 'redux-act';

import { IRedeemResponse } from './redeem.types';

export const loadRedeemRequest = createAction<string>('REDEEM/LOAD_REDEEM_REQUEST');

export const loadRedeemSuccess = createAction<IRedeemResponse>('REDEEM/LOAD_REDEEM_SUCCESS');

export const loadRedeemFail = createAction('REDEEM/LOAD_REDEEM_FAIL');
